const baseUrl = process.env.REACT_APP_BASE_URL;
const appUrl = process.env.REACT_APP_URL;

const REQUEST_TIMEOUT_MS = 30000;

function fetchWithTimeout(url, options) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(id));
}

let api = {
  getHeaders() {
    let authUser = localStorage.getItem("authUser");
    authUser = authUser ? JSON.parse(authUser) : null;
    return {
      "Content-Type": "application/json",
      auth: authUser ? authUser.token : ""
    };
  },

  async getApi(path) {
    const url = baseUrl + path;
    try {
      const response = await fetchWithTimeout(url, {
        method: "GET",
        headers: api.getHeaders()
      });
      if (!response.ok) return { status: 'failure', message: response.statusText };
      return await response.json();
    } catch (error) {
      return { status: 'failure', message: String(error) };
    }
  },

  async getAppApi(path) {
    const url = appUrl + path;
    try {
      const response = await fetchWithTimeout(url, {
        method: "GET",
        headers: api.getHeaders()
      });
      if (!response.ok) return { status: 'failure', message: response.statusText };
      return await response.json();
    } catch (error) {
      return { status: 'failure', message: String(error) };
    }
  },
};

export default api;
